import { Close, GroupAddOutlined } from "@mui/icons-material";
import { Box, Dialog, DialogTitle, Grid2, IconButton, Stack, Step, StepLabel, Stepper, Typography, useMediaQuery } from "@mui/material";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import NewCommunityTariffPlanDialogContent from "../tariff-plan/NewCommunityTariffPlanDialogContent";

const NewCommunityMemberConfigureTariffPlanDialog = ({ open, onClose, handleSuccess, initialCommunity = null, initialMember = null }) => {

    const { t } = useTranslation();

    const isMobileVersion = useMediaQuery((theme) => theme.breakpoints.down('lg'));

    return (
        <Dialog open={open} fullScreen>
            <DialogTitle>
                <Grid2 container>
                    <Grid2 item size={{ xs: 9, sm: 6 }}>
                        <Stack spacing={2} direction="row" alignItems={"center"}>
                            <IconButton onClick={onClose}>
                                <Close />
                            </IconButton>
                            <GroupAddOutlined color="primary" />
                            <Typography variant="subtitle1" color="textPrimary">{t("label.button.newMember")}</Typography>
                        </Stack>
                    </Grid2>
                    <Grid2 item size={{ xs: 3, sm: 6 }} alignItems={"center"}>
                        <Box sx={{ display: 'flex', flexGrow: 1, height: "100%", alignItems: "center", justifyContent: "flex-end" }}>
                            <Stepper activeStep={2} orientation="horizontal">
                                <Step key={0}>
                                    <StepLabel>{!isMobileVersion && t("label.title.configureInstallation")}</StepLabel>
                                </Step>
                                <Step key={1}>
                                    <StepLabel>{!isMobileVersion && t("label.title.configureClient")}</StepLabel>
                                </Step>
                                <Step key={2}>
                                    <StepLabel>{!isMobileVersion && t("label.title.configureTariffPlan")}</StepLabel>
                                </Step>
                            </Stepper>
                        </Box>
                    </Grid2>
                </Grid2>
            </DialogTitle>
            <NewCommunityTariffPlanDialogContent open={open} handleSuccess={handleSuccess} initialCommunity={initialCommunity} initialMember={initialMember} />
        </Dialog>
    );
};

export default NewCommunityMemberConfigureTariffPlanDialog;